import Service from 'react-reservice';

import paymentUrlAPI from '@webtrader/core/api/payment/url';

interface IPaymentContext {
  loading: boolean;
  paymentUrl?: string;
}

const defaultContext: IPaymentContext = {
  loading: true
};

class PaymentService extends Service<IPaymentContext> {
  constructor() {
    super();

    this.context = {
      ...defaultContext
    };
  }

  public init = () => {
    this.fetchPaymentUrl();
  };

  private fetchPaymentUrl = async () => {
    try {
      this.context.loading = true;

      const { result } = await paymentUrlAPI();

      if (result) {
        this.context.paymentUrl = result;
      }
    } catch {
    } finally {
      this.context.loading = false;
    }
  };
}

export default new PaymentService();
